import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';

const Navbar = ({ onAboutClick }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleNavigation = (e, path, sectionId) => {
        e.preventDefault();
        setIsMenuOpen(false); // Close menu on link click

        if (location.pathname !== path) {
            navigate(path);
            if (sectionId) {
                // Wait for the new route to render before scrolling
                setTimeout(() => {
                    const el = document.querySelector(sectionId);
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            } else {
                document.querySelector('.scroll-container')?.scrollTo({ top: 0, behavior: 'smooth' });
            }
        } else {
            // Already on the right page
            if (sectionId === '#about' && onAboutClick) {
                onAboutClick();
            } else if (sectionId) {
                const el = document.querySelector(sectionId);
                if (el) el.scrollIntoView({ behavior: 'smooth' });
            } else {
                document.querySelector('.scroll-container')?.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
    };

    return (
        <nav id="navbar">
            <div className="container">
                <div className="logo-cell">
                    <a href="/" onClick={(e) => handleNavigation(e, '/', null)} aria-label="Aerogen Home" className="logo-link">
                        <img src="/images/logo.png" alt="Aerogen Logo" className="navbar-logo-img" />
                        <span className="logo-text">Aerogen, Inc.</span>
                    </a>
                </div>

                <div className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
                    <div className="nav-item">
                        <a href="/#about" onClick={(e) => handleNavigation(e, '/', '#about')}>About</a>
                    </div>
                    <div className="nav-item">
                        <a href="/#services" onClick={(e) => handleNavigation(e, '/', '#services')}>Services</a>
                    </div>
                    <div className="nav-item">
                        <a href="/partnerships" onClick={(e) => handleNavigation(e, '/partnerships', null)}>Partnerships</a>
                    </div>
                    <div className="nav-item">
                        <a href="/#contact" onClick={(e) => handleNavigation(e, '/', '#contact')}>Contact</a>
                    </div>
                </div>

                <div className="hamburger-container" onClick={toggleMenu} aria-label="Toggle menu" aria-expanded={isMenuOpen}>
                    <div className="hamburger-menu">
                        <div className={`line line1 ${isMenuOpen ? 'open' : ''}`}></div>
                        <div className={`line line2 ${isMenuOpen ? 'open' : ''}`}></div>
                        <div className={`line line3 ${isMenuOpen ? 'open' : ''}`}></div>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;